import {Pipe} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';

@Pipe({name: 'secureStyle'})
export class SecureStylePipe {

    constructor(private sanitizer: DomSanitizer) {
        this.sanitizer = sanitizer;
    }

    transform(url: string): SafeStyle {
        const backendUrl = `${environment.backendApiUrl}/` + url;
        return this.sanitizer.bypassSecurityTrustStyle('url(' + backendUrl + ')');
    }
}
